import { useMatches } from '@tanstack/react-router'

export interface Crumb {
    label: string
    to: string
}

/**
 * Routes contribute their own crumb label via `staticData.crumb`, or a loader can
 * set a dynamic one (a user's name rather than their ObjectId) through
 * `loaderData.crumb`. Deriving crumbs from the URL alone would put raw ids in the
 * trail, which tells an operator nothing about where they are.
 *
 * The one derivation of the trail: the header, the route announcer and the tab title
 * all read it here, so the three cannot drift into naming the same page differently.
 */
export function useCrumbs(): Crumb[] {
    return useMatches()
        .map(match => {
            const fromLoader = (match.loaderData as { crumb?: string } | undefined)?.crumb
            const fromStatic = (match.staticData as { crumb?: string } | undefined)?.crumb
            const label = fromLoader ?? fromStatic
            return label ? { label, to: match.pathname } : null
        })
        .filter((crumb): crumb is Crumb => crumb !== null)
}
